import store from '../../store/index.js'

export const globalFetch = async (urlOrRequest, init = {}) => {
    let request

    if (typeof urlOrRequest === 'string') {
        request = new Request(urlOrRequest, {
            ...init,
            body: init.body
        })
    } else if (urlOrRequest instanceof Request) {
        request = new Request(urlOrRequest, {
            body: init.body || urlOrRequest.body,
            method: init.method || urlOrRequest.method,
            headers: init.headers || urlOrRequest.headers
        })
    }

    request.headers.append("CMS-PAGE-ID", store.state.main.page_id)
 
    return fetch(request)
}

// These helpers resolve rather than reject, so callers must be able to tell a
// failure from a payload. `hasError` matches the shape the endpoints already
// return for handled errors.
export const requestFailure = (error) => ({
    hasError: true,
    error: error?.message ?? String(error)
})

export const get = async (url, callback) => {
    return globalFetch(url)
        .then((response) => {
            if (response.ok) {
                const contentType = response.headers.get("Content-Type");
                if (contentType && contentType.includes("application/json")) {
                    return response.json()
                }
                return {}
            }
            throw new Error(`${response.status} ${response.statusText}`)
        })
        .then((json) => {
            if (callback) {
                callback()
            }
            return json
        })
        .catch((error) => {
            console.error("Error:", error)
            return requestFailure(error)
        })
}

export const post = async (url, data, callback, noHeader, pageId, noReturn) => {
    const method = process.env.POSTMETHOD
    return sendRequest(url, data, callback, noHeader, method, pageId, noReturn)
}

export const deleteRequest = async (url, data, callback, noHeader) => {
    const method = process.env.DELETEMETHOD
    return sendRequest(url, data, callback, noHeader, method)
}

export const put = async (url, data, callback, noHeader, pageId) => {
    const method = process.env.PUTMETHOD
    return sendRequest(url, data, callback, noHeader, method)
}



const sendRequest = async (url, data, callback, noHeader, method, pageId, noReturn) => {    
    const headers = new Headers()
    if (!noHeader) {
        headers.append("Content-Type", "application/json")
        headers.append("PageID", pageId)
    }

    const init = {
        headers,
        method,
        body: data ?? '',
    }
    if (method == "GET") delete init.body // leave this in

    return globalFetch(url, init)
        .then((response) => {
            if (response.ok) {
                if(noReturn) return {}
                const contentType = response.headers.get("Content-Type");
                if (contentType && contentType.includes("application/json")) {
                    return response.json()
                }
                return {}
            }
            throw new Error(`${response.status} ${response.statusText}`)
        })
        .then((json) => {
            if (callback) {
                callback(json)
            }
            return json
        })
        .catch((error) => {
            console.error("Error:", error)
            return requestFailure(error)
        })
}
